export default class UrlParamsManager {
  constructor(paramName) {
    this.paramName = paramName;
  }

  getValue() {
    const params = new URLSearchParams(window.location.search);
    return params.get(this.paramName);
  }
  setValue(value) {
    const params = new URLSearchParams(window.location.search);
    params.set(this.paramName, value);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    this.replaceUrl(newUrl);
  }

  getValues() {
    const params = new URLSearchParams(window.location.search);
    return params.getAll(this.paramName);
  }

  setValues(values) {
    const params = new URLSearchParams(window.location.search);
    params.delete(this.paramName);
    values.forEach((value) => {
      params.append(this.paramName, value);
    });
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    this.replaceUrl(newUrl);
  }

  removeValues() {
    const params = new URLSearchParams(window.location.search);
    params.delete(this.paramName);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    this.replaceUrl(newUrl);
  }

  replaceUrl(newUrl) {
    window.history.replaceState({}, "", newUrl);
    window.dispatchEvent(new Event("urlParamsChanged"));
  }
}
